'use client'

import { Box, Popover, Portal, Text } from '@chakra-ui/react'
import Image from 'next/image'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import LeidSmartDescription from './LeidSmartDescription'
import { ParsedPricingInfo } from 'utils/apiUtils/prices'

type Props = {
  pricing: ParsedPricingInfo
}

const LeidSmartBadge = ({ pricing }: Props) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)

  return (
    <Box position="absolute" top="10px" right="10px">
      <Popover.Root open={open} onOpenChange={(e) => setOpen(e.open)} positioning={{ placement: 'top-end' }}>
        <Popover.Trigger onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
          <Image src="/leid_smart/badge-small.svg" alt="Leid Smart" width={150} height={48} />
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content css={{ '--popover-bg': 'black' }} width="320px" borderRadius="16px">
              <Popover.Arrow />
              <Popover.Header
                color="white"
                fontSize="sm"
                fontWeight="medium"
                lineHeight="normal"
                borderBottom="1px solid"
                borderColor="updatedLeid.lightGreen"
                paddingBottom="4px"
              >
                15% {t('leidSmart.cashback')}
              </Popover.Header>
              <Popover.Body color="white">
                <Box>
                  <Text fontSize="sm" paddingBottom="10px" paddingLeft="15px">
                    {t('leidSmart.leidSmartShortTerms.title')}
                  </Text>

                  <LeidSmartDescription pricing={pricing} inverted />
                </Box>
              </Popover.Body>
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>
    </Box>
  )
}

export default LeidSmartBadge
